import { initializeSections } from "./accordion-helper";

// Select accordion sections
let sections = document.querySelectorAll(".accordion__section");

// Initialize on page load
initializeSections(sections);
